import { only } from 'styled-breakpoints'
import { css } from 'styled-components'
import { MOBILE, TABLET } from '../lib/constant'

const typography = {
	display: {
		xxl: css`
			font-size: 144px;
			line-height: 148px;
			letter-spacing: -0.04em;
			${only(TABLET)} {
				font-size: 84px;
				line-height: 88px;
			}
			${only(MOBILE)} {
				font-size: 56px;
				line-height: 60px;
			}
		`,
		xl: css`
			font-size: 128px;
			line-height: 132px;
			letter-spacing: -0.04em;
			${only(TABLET)} {
				font-size: 80px;
				line-height: 84px;
			}
			${only(MOBILE)} {
				font-size: 52px;
				line-height: 56px;
			}
		`,
		l: css`
			font-size: 112px;
			line-height: 116px;
			letter-spacing: -0.02em;
			${only(TABLET)} {
				font-size: 72px;
				line-height: 76px;
			}
			${only(MOBILE)} {
				font-size: 48px;
				line-height: 52px;
			}
		`,
		m: css`
			font-size: 96px;
			line-height: 100px;
			letter-spacing: -0.02em;
			${only(TABLET)} {
				font-size: 64px;
				line-height: 68px;
			}
			${only(MOBILE)} {
				font-size: 44px;
				line-height: 48px;
			}
		`,
		s: css`
			font-size: 84px;
			line-height: 96px;
			letter-spacing: -0.02em;
			${only(TABLET)} {
				font-size: 60px;
				line-height: 64px;
			}
			${only(MOBILE)} {
				font-size: 40px;
				line-height: 44px;
			}
		`,
	},
	heading: {
		xxl: css`
			font-size: 72px;
			line-height: 76px;
			letter-spacing: -0.02em;
			${only(TABLET)} {
				font-size: 54px;
				line-height: 58px;
			}
			${only(MOBILE)} {
				font-size: 40px;
				line-height: 44px;
			}
		`,
		xl: css`
			font-size: 64px;
			line-height: 68px;
			letter-spacing: -0.03em;
			${only(TABLET)} {
				font-size: 48px;
				line-height: 52px;
			}
			${only(MOBILE)} {
				font-size: 36px;
				line-height: 40px;
			}
		`,
		l: css`
			font-size: 56px;
			line-height: 60px;
			letter-spacing: -0.03em;
			${only(TABLET)} {
				font-size: 40px;
				line-height: 44px;
			}
			${only(MOBILE)} {
				font-size: 32px;
				line-height: 36px;
			}
		`,
		m: css`
			font-size: 48px;
			line-height: 52px;
			letter-spacing: -0.03em;
			${only(TABLET)} {
				font-size: 36px;
				line-height: 40px;
			}
			${only(MOBILE)} {
				font-size: 28px;
				line-height: 32px;
			}
		`,
		s: css`
			font-size: 44px;
			line-height: 48px;
			letter-spacing: -0.03em;
			${only(TABLET)} {
				font-size: 32px;
				line-height: 36px;
			}
			${only(MOBILE)} {
				font-size: 24px;
				line-height: 28px;
			}
		`,
		xs: css`
			font-size: 40px;
			line-height: 44px;
			letter-spacing: -0.03em;
			${only(TABLET)} {
				font-size: 28px;
				line-height: 32px;
			}
			${only(MOBILE)} {
				font-size: 20px;
				line-height: 24px;
			}
		`,
	},
	label: {
		xxxl: css`
			font-size: 32px;
			line-height: 36px;
			letter-spacing: -0.02em;
			${only(TABLET)} {
				font-size: 24px;
				line-height: 28px;
			}
			${only(MOBILE)} {
				font-size: 22px;
				line-height: 26px;
			}
		`,
		xxl: css`
			font-size: 24px;
			line-height: 28px;
			letter-spacing: -0.02em;
			${only(TABLET)} {
				font-size: 20px;
				line-height: 24px;
			}
			${only(MOBILE)} {
				font-size: 20px;
				line-height: 24px;
			}
		`,
		xl: css`
			font-size: 18px;
			line-height: 22px;
			letter-spacing: -0.02em;
		`,
		l: css`
			font-size: 16px;
			line-height: 20px;
			letter-spacing: -0.02em;
		`,
		m: css`
			font-size: 14px;
			line-height: 18px;
			letter-spacing: -0.02em;
		`,
		s: css`
			font-size: 12px;
			line-height: 16px;
			letter-spacing: -0.01em;
		`,
	},
	paragraph: {
		xxl: css`
			font-size: 24px;
			line-height: 36px;
		`,
		xl: css`
			font-size: 18px;
			line-height: 28px;
		`,
		l: css`
			font-size: 16px;
			line-height: 24px;
		`,
		m: css`
			font-size: 14px;
			line-height: 20px;
		`,
		s: css`
			font-size: 12px;
			line-height: 20px;
		`,
	},
}

export default typography

export const getTypography = (size) => size
